import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthenticationService } from "../authentication/authentication.service";
import { Observable } from "rxjs/Observable";
import { AdminService } from "../api/services";
import { Tokens } from "../api/models";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class TokenGuard implements CanActivate {
  public token;
  public databasetoken: Tokens = null;

  constructor(
    private router: Router,
    private apiAdmin: AdminService,
    private toastr: ToastrService,
    private auth: AuthenticationService
  ) {
    this.apiAdmin.getLoginTokens().subscribe(
      (data) => {
        // console.log('datatoken1');
        this.databasetoken = data;
      },
      (err) => {
        console.log("err1");
      },
      () => {}
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.apiAdmin.getLoginTokens().subscribe(
      (data) => {
        // console.log('datatoken2');
        this.databasetoken = data;
      },
      (err) => {
        console.log('err2',err);
        // this.auth.logout();
        this.router.navigate(["/auth/signin"]);
        this.toastr.error("ERROR", "CO0272:The access token expired");
        return false;
      },
      () => {}
    );

    // local and database not compare
    // local and database not compare
    if (localStorage.getItem("token") && this.databasetoken) {
      if (Number(this.databasetoken.TYPE) === 0) {
        // console.log('err3');
        // this.auth.logout();
        this.router.navigate(["/auth/signin"]);
        this.toastr.error("ERROR", "CO0272:The access token expired");
        return false;
      } else {
        if (Number(this.databasetoken.TYPE) === 1) {
          return true;
        }
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/guards/token.guard.ts